export function fetchYoutubeThumbnail(url: string, quality?: string): string {
  if (!url) {
    return '';
  }

  let video_id: string | null = null;
  let result: RegExpMatchArray | null;

  result = url.match(/youtube\.com.*(\?v=|\/embed\/)([a-zA-Z0-9_-]{11})/);
  if (result && result[2]) {
    video_id = result[2];
  } else {
    result = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (result && result[1]) {
      video_id = result[1];
    }
  }

  if (video_id) {
    if (typeof quality === 'undefined') {
      quality = 'high';
    }

    let quality_key = 'maxresdefault';
    if (quality === 'low') {
      quality_key = 'sddefault';
    } else if (quality === 'medium') {
      quality_key = 'mqdefault';
    } else if (quality === 'high') {
      quality_key = 'hqdefault';
    }

    return `https://img.youtube.com/vi/${video_id}/${quality_key}.jpg`;
  }

  return 'content/images/images_v3/common/go-empty-thumb-sz64.png';
}

export function convertToEmbedUrl(videoUrl: string) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com(?:\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  const match = videoUrl.match(regex);

  if (match) {
    return 'https://www.youtube.com/embed/' + match[1];
  } else {
    return videoUrl;
  }
}
